import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// material
import { Paper, Typography } from '@mui/material';
// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string,
};

export default function SearchNotFound({ searchQuery = '', ...other }) {
  const { t } = useTranslation();
  return (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        {t('people.search_not_found_title')}
      </Typography>
      <Typography variant="body2" align="center">
        {t('people.search_not_found')} &nbsp;
        <strong>&quot;{searchQuery}&quot;</strong>. {t('people.search_try_again')}
      </Typography>
    </Paper>
  );
}
